export enum IdentityScreen {
    SUCCESS = 'identity-screen-success--active',
    ERROR = 'identity-screen-error--active',
    FORM = 'identity-screen-form--active'
}
